import { render, staticRenderFns } from "./ds-manager-table.vue?vue&type=template&id=59430d80&"
import script from "./ds-manager-table.vue?vue&type=script&lang=js&"
export * from "./ds-manager-table.vue?vue&type=script&lang=js&"
import style0 from "./ds-manager-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ds-manager-table.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports